import { plainToClass } from "class-transformer";
import { CompanyResponse, MarkResponse, ModelResponse, ModificationResponse } from '@/services/index.defs';
import { DictsService } from '@/services/DictsService';

export class DictiModule {
    isProvidersLoading: boolean = false;
    isLoading: boolean = false;
    isSaving: boolean = false;

    providers: CompanyResponse[] = [];
    mapMarks: MarkResponse[] = [];
    mapModels: ModelResponse[] = [];
    modifications: ModificationResponse[] = [];
}

export default {
    namespaced: true as true,
    state: new DictiModule(),

    mutations: {
        setMapModels(state: DictiModule, data: ModelResponse[]) {
            state.mapModels = data;
        },
        setModification(state: DictiModule, data: ModificationResponse[]) {
            state.modifications = data.map(x => plainToClass(ModificationResponse, x))
            const defModification = new ModificationResponse();
            defModification.title = "Другая модификация";
            state.modifications.push(defModification)
        }
    },
    actions: {
        async getInsuranceProviders({ state }): Promise<CompanyResponse[]> {
            state.isProvidersLoading = true;
            const res: CompanyResponse[] = await DictsService.company();
            state.providers = res;
            state.isProvidersLoading = false;
            return res;
        },
        async getMapMarks({ state }): Promise<MarkResponse[]> {
            const res: MarkResponse[] = await DictsService.mark();
            state.mapMarks = res;
            return res;
        },
        async getMapModels({ state, commit }, mapMarkId: string): Promise<ModelResponse[]> {
            const res: ModelResponse[] = await DictsService.model({ markId: mapMarkId });
            commit("setMapModels", res);
            return res;
        },
        async getModifications({ state, commit }, modelId: string): Promise<ModificationResponse[]> {
            const res = await DictsService.modifications({ modelId: modelId });
            commit("setModification", res);
            return state.modifications;
        },
    },
}
